import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  key: 0,
  class: "smTitle"
};
const _hoisted_3 = {
  key: 1,
  class: "flex orline"
};
import { ArrowLeftBold } from "@element-plus/icons-vue";
import ThemeChange from "@/components/ThemeChange.vue";
import { useRouter } from "vue-router";
import { showMessageInfo } from "@/utils/dialog";
export default {
  __name: 'AccountTop',
  props: {
    userType: {
      type: String,
      default: "personal"
    },
    title: {
      type: String,
      default: "登录"
    },
    smTitle: {
      type: String,
      default: "没有账号？"
    },
    goPage: {
      type: String,
      default: "/register"
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const goBack = () => {
      if (props.title === "注册") {
        router.push("/");
      } else {
        router.go(-1);
      }
    };
    const goPageFun = () => {
      if (props.title === "登录") {
        if (props.userType !== 'personal') {
          showMessageInfo('企业用户暂未开放注册！');
          return;
        }
        router.push("/register");
      } else {
        router.push("/login");
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(ThemeChange), _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1), __props.title !== '重置密码' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createTextVNode(_toDisplayString(__props.title === "登录" ? "没有账号？" : "已有账号？"), 1), _createElementVNode("span", {
        onClick: goPageFun,
        class: "text-color-primary sign"
      }, "赶紧" + _toDisplayString(__props.title === "登录" ? "注册" : "登录"), 1)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default"), __props.title !== '重置密码' ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true)]);
    };
  }
};